import {
  SparklesIcon,
  PlusIcon,
  CodeBracketIcon,
} from "@heroicons/react/24/outline";
import { Button } from "@/components";

interface EmptyStateProps {
  onGenerateWithAI: () => void;
  onCreateManually: () => void;
  isGeneratingSchema: boolean;
}

export function EmptyState({
  onGenerateWithAI,
  onCreateManually,
  isGeneratingSchema,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 space-y-6">
      <div className="text-center space-y-4">
        <CodeBracketIcon className="h-16 w-16 text-gray-400 mx-auto" />
        <div>
          <h3 className="text-lg font-medium text-gray-900">
            Schema Técnico não definido
          </h3>
          <p className="text-gray-600 max-w-md">
            Crie o schema técnico do projeto com modelos de dados, APIs e
            documentação usando IA ou manualmente.
          </p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          onClick={onGenerateWithAI}
          disabled={isGeneratingSchema}
          leftIcon={<SparklesIcon className="h-4 w-4" />}
          className="bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700"
        >
          {isGeneratingSchema ? "Gerando..." : "Gerar com IA"}
        </Button>

        <Button
          variant="outline"
          onClick={onCreateManually}
          leftIcon={<PlusIcon className="h-4 w-4" />}
        >
          Criar Manualmente
        </Button>
      </div>
    </div>
  );
}